// src/components/AdminLogin.jsx
import React, { useState } from 'react';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../firebase';

export default function AdminLogin({ onLogin, onCancel }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      onLogin && onLogin(result.user); // Pass user object up
    } catch (err) {
      setError('Login failed. Please check your credentials.');
    }
    setLoading(false);
  };

  return (
    <form className="guestbook-form" onSubmit={handleLogin} style={{ maxWidth: 360 }}>
      <h3 style={{ textAlign: 'center', color: '#7c53c3', marginBottom: 12 }}>Admin Login</h3>
      <label htmlFor="admin-email">Email</label>
      <input
        id="admin-email"
        type="email"
        value={email}
        autoComplete="username"
        onChange={e => setEmail(e.target.value)}
        required
      />
      <label htmlFor="admin-password">Password</label>
      <input
        id="admin-password"
        type="password"
        value={password}
        autoComplete="current-password"
        onChange={e => setPassword(e.target.value)}
        required
      />
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
        <button type="submit" disabled={loading} style={{ flex: 1 }}>
          {loading ? "Logging in..." : "Login"}
        </button>
        {onCancel &&
          <button
            type="button"
            className="copy-btn"
            style={{ flex: 1, background: "#f4f2fd", color: "#5e3694" }}
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
        }
      </div>
      {error && <div style={{ color: 'crimson', marginTop: 8, textAlign: 'center' }}>{error}</div>}
    </form>
  );
}
